import type { DateTimeFormatStyle } from "@hopper-b2b/i18n";
// customParseFormat is globally extended by @hopper-b2b/utilities/dayjsHelpers
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

interface CalculateEndTimeLabelParams {
  startDate: Dayjs;
  startTime: string | undefined;
  durationMinutes: number;
  t: (key: string, options?: Record<string, unknown>) => string;
  formatDateTime: (date: Date, style: DateTimeFormatStyle) => string;
  DateTimeFormatStyle: typeof DateTimeFormatStyle;
}

export function calculateEndTimeLabel({
  startDate,
  startTime,
  durationMinutes,
  t,
  formatDateTime,
  DateTimeFormatStyle,
}: CalculateEndTimeLabelParams): string {
  if (!startTime || durationMinutes <= 0 || !startDate.isValid()) return "";

  const parsedTime = dayjs(startTime, ["h:mm A", "hh:mm A", "HH:mm"]);
  if (!parsedTime.isValid()) return "";

  const endDateTime = startDate
    .hour(parsedTime.hour())
    .minute(parsedTime.minute())
    .add(durationMinutes, "minute");

  return t("activities.postBooking.localTimeLabel", {
    date: formatDateTime(
      endDateTime.toDate(),
      DateTimeFormatStyle.ShortMonthDayShortWeekday
    ),
    time: formatDateTime(endDateTime.toDate(), DateTimeFormatStyle.ShortTime),
  });
}
